import { render, staticRenderFns } from "./DictIndex.vue?vue&type=template&id=61a82fb6&scoped=true"
import script from "./DictIndex.vue?vue&type=script&lang=js"
export * from "./DictIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a82fb6",
  null
  
)

export default component.exports